import { Link } from '@reach/router';
import React from 'react';
import styled from 'styled-components';
import { Card } from '../ui';
import { variables } from '../utils';
import SummaryRow from './SummaryRow';
import LastEntryTime from './LastEntryTime';
import { SummaryCardProps } from './types';
import Members from './Members';

const LeftCol = styled.div.attrs({
  className: 'w-third-ns pa3 pt4-ns flex flex-column-ns justify-between items-center items-start-ns'
})`
  @media (max-width: ${variables.medium}px) {
    border-bottom: 1px solid ${variables.lightGray};
  }
  @media (min-width: ${variables.medium}px) {
    border-right: 1px solid ${variables.lightGray};
  }
`;

const RightCol = styled.div.attrs({
  className: 'w-two-thirds-ns pa3 pa4-ns'
})``;

const SummaryCard: React.FC<SummaryCardProps> = ({ item }) => {
  const { slug, name, id, type, trackers, subjects = [] } = item;

  return (
    <Link
      to={`/notebook/${type.toLowerCase()}/${encodeURIComponent(slug)}`}
      state={{ isEmpty: trackers.length === 0 }}
      key={id}
      className="db"
      data-testid={`summary-${slug}`}
    >
      <Card className="mb2">
        <div className="flex-ns">
          <LeftCol>
            <div className="w-80 w-100-ns">
              <h2 className="f4 fw6 mt1 mt0-ns mb1">
                {name}
                {item.type === 'GROUP' && <sup className="f7 fw5 tnum ph1">{subjects.length}</sup>}
              </h2>
              <LastEntryTime item={item} />
            </div>

            <Members item={item} />
          </LeftCol>

          <RightCol>
            {trackers.map((tracker, index: number) => (
              <SummaryRow item={item} tracker={tracker} index={index} key={`${tracker.id}`} />
            ))}
            {trackers.length === 0 && (
              <>
                <p className="mt0 mb2 f7 serif">Create a question or metric.</p>
                <p className="mv0 f7 blue hover-navy">Go To Settings</p>
              </>
            )}
          </RightCol>
        </div>
      </Card>
    </Link>
  );
};

export default SummaryCard;
